module.exports = __webpack_public_path__ + "media/images/icons/scroll_left_navigation-f3f57996c3e2bb23013460a2bfb14d56.svg";